module.exports = __webpack_public_path__ + "media/images/index_exchange_logo-1ab8a7dbb94d529399e2d254b5287fbd.png";